'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_copyOnClick$() {
}
export { $c_Lpresto_copyOnClick$ as $c_Lpresto_copyOnClick$ };
$p = $c_Lpresto_copyOnClick$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_copyOnClick$;
/** @constructor */
function $h_Lpresto_copyOnClick$() {
}
export { $h_Lpresto_copyOnClick$ as $h_Lpresto_copyOnClick$ };
$h_Lpresto_copyOnClick$.prototype = $p;
$p.fm = (function(label, value) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.n().d($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.g.h("cursor-pointer"), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a, label, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$().m), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_EventListener(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_keys_EventProcessor$().W($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.ab(), false, false)), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$10) => {
    window.navigator.clipboard.writeText(value);
  })))])));
});
var $d_Lpresto_copyOnClick$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_copyOnClick$, "presto.copyOnClick$", ({
  Vg: 1
}));
export { $d_Lpresto_copyOnClick$ as $d_Lpresto_copyOnClick$ };
var $n_Lpresto_copyOnClick$;
function $m_Lpresto_copyOnClick$() {
  if ((!$n_Lpresto_copyOnClick$)) {
    $n_Lpresto_copyOnClick$ = new $c_Lpresto_copyOnClick$();
  }
  return $n_Lpresto_copyOnClick$;
}
export { $m_Lpresto_copyOnClick$ as $m_Lpresto_copyOnClick$ };
//# sourceMappingURL=presto.copy-On-Click$.js.map
